import { configApp } from './parser';

const Configs = {
    HOME: {
        STORES_IN_ZONES: configApp('SHOW_HOME_STORES_IN_ZONES', true),
    },
    SECONDARY_MENU: {
        STORES: configApp('SHOW_SECONDARY_MENU_STORES', true),
        CATEGORIES: configApp('SHOW_SECONDARY_MENU_CATEGORIES', true),
    },
    GOOGLE_ANALYTICS: {
        ENABLE: configApp('GOOGLE_ANALYTICS_ENABLE_TAG', true),
        TRACKING_ID: configApp('GOOGLE_ANALYTICS_TRACKING_ID', 'G-E5VSDLHG6E'),
    },
    ROUTES: {
        ENABLE_MERCADO_UNICO_PRODUCTS: configApp('ROUTE_ENABLE_MERCADO_UNICO_PRODUCTS', true),
    },
};

export default Configs;



/** WEBPACK FOOTER **
 ** ./src/configs/index.js
 **/